import type { GetMeQuery, GetMeQueryVariables } from 'generated/graphql';
import { createContextedQuery } from 'modules/Apollo/createContextedQuery';
import { GET_ME } from 'modules/Apollo/queries';

export const { Provider: CurrentUserQueryProvider, useQuery: useCurrentUserQuery } =
  createContextedQuery<GetMeQuery, GetMeQueryVariables>(GET_ME, {
    name: 'CurrentUserQuery',
  });
